/**
 * getBookmarkActions.js
 * Created by calhosh on 8/28/2020.
 */
import * as types from '../actiontypes';

export function getBookmarkAction(requestUrl, baseUrl, workspaceId) {
	return {
		type: types.GET_BOOKMARK_TASKS,
		meta: {
			api: {
				url: requestUrl,
				method: 'GET'
			},
			url: baseUrl,
			workspaceId: workspaceId
		}
	};
}
